import React, { useState } from 'react';
import { Container, Box, Typography, Grid, Paper, Stack, Chip, Button } from '@mui/material';
import { theme, commonStyles } from '../../../styles/theme';
import { featureShowcases } from './homePageData.jsx';
import FeatureDialog from './FeatureDialog';

const FeaturesTab = () => {
	const [selectedFeature, setSelectedFeature] = useState(null);

	const handleOpenFeature = (feature) => {
		setSelectedFeature(feature);
	};

	const handleCloseFeature = () => {
		setSelectedFeature(null);
	};

	return (
		<>
			<Container maxWidth="lg" sx={{ py: { xs: 4, md: 8 }, px: { xs: 2, sm: 3 } }}>
				<Box sx={{ textAlign: 'center', mb: { xs: 4, md: 8 } }}>
					<Typography variant="h3" sx={{ fontWeight: 800, background: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', mb: 2 }}>
						Features Overview
					</Typography>
					<Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.7)', maxWidth: 900, mx: 'auto' }}>
						Comprehensive tools for professional NFT generation
					</Typography>
				</Box>
				<Grid container spacing={{ xs: 2, sm: 3, md: 4 }}>
					{featureShowcases.map((feature) => (
						<Grid item xs={12} md={6} key={feature.title}>
							<Paper
								sx={{
									p: { xs: 2, sm: 3, md: 4 },
									height: '100%',
									...commonStyles.card,
									display: 'flex',
									flexDirection: 'column',
									gap: 2
								}}
							>
								<Stack spacing={2} sx={{ flexGrow: 1 }}>
									<Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
										<Chip label={feature.tag} size="small" sx={{ bgcolor: 'rgba(220,38,38,0.12)', color: theme.colors.primary, fontWeight: 700 }} />
										<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
											{feature.icon}
										</Box>
									</Box>
									<Typography variant="h5" sx={{ fontWeight: 800, color: '#fff' }}>{feature.title}</Typography>
									<Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.72)', lineHeight: 1.7 }}>
										{feature.description}
									</Typography>
									<Grid container spacing={1.5}>
										{feature.proofPoints.map((proof) => (
											<Grid item xs={12} sm={4} key={proof.label}>
												<Box sx={{
													p: 1.5,
													border: `1px solid ${theme.colors.borderPrimary}`,
													borderRadius: 2,
													bgcolor: 'rgba(255,255,255,0.03)'
												}}>
													<Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.55)', textTransform: 'uppercase', letterSpacing: 0.5 }}>
														{proof.label}
													</Typography>
													<Typography variant="body2" sx={{ color: '#fff', fontWeight: 600 }}>
														{proof.value}
													</Typography>
												</Box>
											</Grid>
										))}
									</Grid>
								</Stack>
								<Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
									<Button size="small" variant="outlined" onClick={() => handleOpenFeature(feature)}>
										Learn more
									</Button>
								</Box>
							</Paper>
						</Grid>
					))}
				</Grid>
			</Container>

			<FeatureDialog
				feature={selectedFeature}
				open={Boolean(selectedFeature)}
				onClose={handleCloseFeature}
			/>
		</>
	);
};

export default FeaturesTab;
